import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './MercurXProjectDetailInputs.scss';
import {
  Nft,
  NftContract,
  PresaleContract,
  PrivateRound,
  ProjectDetail,
  PublicRound,
  RegistrationRound,
  RoundSale,
  Social,
  StakingContract,
  StakingRound,
  Token,
  ValidationRound,
} from '../../models/ProjectDetailModel';
import { Accordion, Button, Col, Form, Row } from 'react-bootstrap';
import { useLocation } from 'react-router';
import moment from 'moment/moment';
import {
  createProjectActionRequest,
  updateProjectActionRequest,
} from '../../store/project/projectActions';
import * as projectActionTypes from '../../store/project/projectActionTypes';
import { createTokenActionRequest, updateTokenActionRequest } from '../../store/token/tokenActions';
import { useHistory } from 'react-router-dom';
import * as endpoints from '../../services/endpoints';

const MercurXProjectDetailInputs = (props) => {
  const {
    isEdit,
    createProjectRequest,
    updateProjectRequest,
    createTokenRequest,
    updateTokenRequest,
    createdProject,
    updatedProject,
    projectErrorType,
    showToken,
    showNft,
    showProject,
    showContract,
    showSocial,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const project = location.state?.project;
  const token = location.state?.token;
  const [projectDetail, setProjectDetail] = useState(new ProjectDetail());

  const [roundSale, setRoundSale] = useState(new RoundSale());
  const [registrationRound, setRegistrationRound] = useState(new RegistrationRound());
  const [stakingRound, setStakingRound] = useState(new StakingRound());
  const [publicRound, setPublicRound] = useState(new PublicRound());
  const [privateRound, setPrivateRound] = useState(new PrivateRound());
  const [validationRound, setValidationRound] = useState(new ValidationRound());

  const [tokenDetail, setTokenDetail] = useState(new Token());
  const [nftDetail, setNftDetail] = useState(new Nft());

  const [stakingContract, setStakingContract] = useState(new StakingContract());
  const [presaleContract, setPresaleContract] = useState(new PresaleContract());
  const [nftContract, setNftContract] = useState(new NftContract());

  const [socialDetail, setSocialDetail] = useState(new Social());

  const [requiredErrors, setRequiredErrors] = useState([]);
  const [DateErrors, setDateErrors] = useState([]);
  const [isCreateProjectSubmitting, setIsCreateProjectSubmitting] = useState(false);
  const [isUpdateProjectSubmitting, setIsUpdateProjectSubmitting] = useState(false);
  const [projectImageFile, setProjectImageFile] = useState(null);
  const [projectLogoFile, setProjectLogoFile] = useState(null);
  const [projectImagePreview, setProjectImagePreview] = useState('');
  const [projectLogoPreview, setProjectLogoPreview] = useState('');
  const [projectImageServerPreview, setProjectImageServerPreview] = useState('');
  const [projectLogoServerPreview, setProjectLogoServerPreview] = useState('');
  const selectedImagePreviewRef = useRef(null);
  const selectedLogoPreviewRef = useRef(null);
  const serverImagePreviewRef = useRef(null);
  const serverLogoPreviewRef = useRef(null);
  const user = JSON.parse(localStorage.getItem('user'))?.user;
  const isNftProjectCreateEditPage =
    showProject &&
    (location.pathname === '/nft-projects/create-new-project' ||
      location.pathname === '/nft-projects/edit-project');

  function normalizeMediaSource(mediaResponse, mediaType) {
    if (mediaResponse instanceof Blob) {
      if (!mediaResponse.size) {
        return '';
      }

      const blobPreview = URL.createObjectURL(mediaResponse);
      if (mediaType === 'image') {
        clearServerImagePreview();
        serverImagePreviewRef.current = blobPreview;
      } else if (mediaType === 'logo') {
        clearServerLogoPreview();
        serverLogoPreviewRef.current = blobPreview;
      }

      return blobPreview;
    }

    const rawValue =
      typeof mediaResponse === 'string'
        ? mediaResponse
        : mediaResponse?.result || mediaResponse?.data || '';

    if (!rawValue || typeof rawValue !== 'string') {
      return '';
    }

    const normalizedValue = rawValue.trim();
    if (!normalizedValue) {
      return '';
    }

    if (normalizedValue.startsWith('data:image')) {
      return normalizedValue;
    }

    if (normalizedValue.startsWith('http://') || normalizedValue.startsWith('https://')) {
      return normalizedValue;
    }

    if (normalizedValue.startsWith('/')) {
      return `${process.env.REACT_APP_API_URL}${normalizedValue}`;
    }

    return `data:image/png;base64,${normalizedValue}`;
  }

  function clearSelectedImagePreview() {
    if (selectedImagePreviewRef.current) {
      URL.revokeObjectURL(selectedImagePreviewRef.current);
      selectedImagePreviewRef.current = null;
    }
  }

  function clearSelectedLogoPreview() {
    if (selectedLogoPreviewRef.current) {
      URL.revokeObjectURL(selectedLogoPreviewRef.current);
      selectedLogoPreviewRef.current = null;
    }
  }

  function clearServerImagePreview() {
    if (serverImagePreviewRef.current) {
      URL.revokeObjectURL(serverImagePreviewRef.current);
      serverImagePreviewRef.current = null;
    }
  }

  function clearServerLogoPreview() {
    if (serverLogoPreviewRef.current) {
      URL.revokeObjectURL(serverLogoPreviewRef.current);
      serverLogoPreviewRef.current = null;
    }
  }
  useEffect(() => {
    if (project) {
      setProjectDetail(new ProjectDetail(project));

      if (project.round_sale) {
        setRoundSale(new RoundSale(project.round_sale));
      }
      if (project.round_registration) {
        setRegistrationRound(new RegistrationRound(project.round_registration));
      }
      if (project.round_staking) {
        setStakingRound(new StakingRound(project.round_staking));
      }
      if (project.round_publicsale) {
        setPublicRound(new PublicRound(project.round_publicsale));
      }
      if (project.round_privatesale) {
        setPrivateRound(new PrivateRound(project.round_privatesale));
      }
      if (project.round_validation) {
        setValidationRound(new ValidationRound(project.round_validation));
      }

      if (project.social) {
        setSocialDetail(new Social(project.social));
      }
      if (project.nft) {
        setNftDetail(new Nft(project.nft));
      }
      if (project.nft?.nft_contract) {
        setNftContract(new NftContract(project.nft.nft_contract));
      }
      //   if (token.staking_contract) {
      //     setStakingContract(new StakingContract(token.staking_contract));
      //   }

      //   if (token.presale_contract) {
      //     setPresaleContract(new PresaleContract(token.presale_contract));
      // }
    } else if (token) {
      console.log(token);
      setTokenDetail(new Token(token));

      if (token.staking_contract) {
        setStakingContract(new StakingContract(token.staking_contract));
      }

      if (token.presale_contract) {
        setPresaleContract(new PresaleContract(token.presale_contract));
      }
    }
  }, []);

  useEffect(() => {
    if (!isCreateProjectSubmitting || isEdit) {
      return;
    }

    if (createdProject) {
      setIsCreateProjectSubmitting(false);
      history.goBack();
      return;
    }

    if (projectErrorType === projectActionTypes.CREATE_PROJECT_ERROR) {
      setIsCreateProjectSubmitting(false);
    }
  }, [createdProject, history, isCreateProjectSubmitting, isEdit, projectErrorType]);

  useEffect(() => {
    if (!isUpdateProjectSubmitting || !isEdit) {
      return;
    }

    if (updatedProject) {
      setIsUpdateProjectSubmitting(false);
      history.goBack();
      return;
    }

    if (projectErrorType === projectActionTypes.UPDATE_PROJECT_ERROR) {
      setIsUpdateProjectSubmitting(false);
    }
  }, [history, isEdit, isUpdateProjectSubmitting, projectErrorType, updatedProject]);

  useEffect(() => {
    let isUnmounted = false;

    async function fetchProjectMedia() {
      if (!isEdit || !project?.id) {
        return;
      }

      try {
        const { data } = await endpoints.getProjectImage(project.id);
        if (!isUnmounted) {
          const imageSource = normalizeMediaSource(data, 'image');
          setProjectImageServerPreview(imageSource);
          setProjectImagePreview(imageSource);
        }
      } catch (error) {
        if (!isUnmounted) {
          clearServerImagePreview();
          setProjectImageServerPreview('');
          setProjectImagePreview('');
        }
      }

      try {
        const { data } = await endpoints.getProjectLogo(project.id);
        if (!isUnmounted) {
          const logoSource = normalizeMediaSource(data, 'logo');
          setProjectLogoServerPreview(logoSource);
          setProjectLogoPreview(logoSource);
        }
      } catch (error) {
        if (!isUnmounted) {
          clearServerLogoPreview();
          setProjectLogoServerPreview('');
          setProjectLogoPreview('');
        }
      }
    }

    fetchProjectMedia();

    return () => {
      isUnmounted = true;
    };
  }, [isEdit, project?.id]);

  useEffect(() => {
    return () => {
      clearSelectedImagePreview();
      clearSelectedLogoPreview();
      clearServerImagePreview();
      clearServerLogoPreview();
    };
  }, []);

  function projectDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    projectDetail[key] = value;
    setProjectDetail({ ...projectDetail });

    const errorKey = 'project_detail_' + key;
    clearError(errorKey);
  }
  function tokenDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    tokenDetail[key] = value;
    setTokenDetail({ ...tokenDetail });
    const errorKey = 'token_detail_' + key;
    clearError(errorKey);
  }
  function nftDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    nftDetail[key] = value;
    setNftDetail({ ...nftDetail });
    const errorKey = 'nft_detail_' + key;
    clearError(errorKey);
  }

  function roundSaleDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:mm:ss.mmmZ');
    }

    roundSale[key] = value;
    setRoundSale({ ...roundSale });

    const errorKey = 'round_sale_' + key;
    clearError(errorKey);
  }

  function registrationRoundDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:mm:ss.mmmZ');
    }

    registrationRound[key] = value;
    setRegistrationRound({ ...registrationRound });

    const errorKey = 'registration_round_' + key;
    clearError(errorKey);
    console.log(errorKey + ':Error key');
  }
  function registrationRoundDetailTextOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    registrationRound[key] = value;
    setRegistrationRound({ ...registrationRound });

    const errorKey = 'registration_round_' + key;
    clearError(errorKey);
  }

  function stakingRoundDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:mm:ss.mmmZ');
    }

    stakingRound[key] = value;
    setStakingRound({ ...stakingRound });

    const errorKey = 'staking_round_' + key;
    clearError(errorKey);
  }
  function stakingRoundDetailTextOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    stakingRound[key] = value;
    setStakingRound({ ...stakingRound });

    const errorKey = 'staking_round_' + key;
    clearError(errorKey);
  }

  function publicRoundDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:mm:ss.mmmZ');
    }

    publicRound[key] = value;
    setPublicRound({ ...publicRound });

    const errorKey = 'public_round_' + key;
    clearError(errorKey);
  }
  function publicRoundDetailTextOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    publicRound[key] = value;
    setPublicRound({ ...publicRound });

    const errorKey = 'public_round_' + key;
    clearError(errorKey);
  }
  function privateRoundDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:mm:ss.mmmZ');
    }

    privateRound[key] = value;
    setPrivateRound({ ...privateRound });

    const errorKey = 'private_round_' + key;
    clearError(errorKey);
  }
  function privateRoundDetailTextOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    privateRound[key] = value;
    setPrivateRound({ ...privateRound });

    const errorKey = 'private_round_' + key;
    clearError(errorKey);
  }

  function validationRoundDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;

    const date = new Date(value);
    if (date) {
      value = moment(date).format('YYYY-MM-DDTHH:MM:SS.mmmZ');
    }

    validationRound[key] = value;
    setValidationRound({ ...validationRound });

    const errorKey = 'validation_round_' + key;
    clearError(errorKey);
  }
  function validationRoundDetailTextOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    validationRound[key] = value;
    setValidationRound({ ...validationRound });

    const errorKey = 'validation_round_' + key;
    clearError(errorKey);
  }

  function stakingContractOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    stakingContract[key] = value;
    setStakingContract({ ...stakingContract });
  }

  function presaleContractOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    presaleContract[key] = value;
    setPresaleContract({ ...presaleContract });
  }
  function nftContractOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    nftContract[key] = value;
    setNftContract({ ...nftContract });
    const errorKey =
      key === 'contract_address' ? 'nft_contract_address' : 'nft_contract_owner_address';
    clearError(errorKey);
  }

  function socialDetailOnChange(e, value) {
    const key = e.target.id;
    if (value === undefined || value === null) value = e.target.value;
    socialDetail[key] = value;
    setSocialDetail({ ...socialDetail });
  }

  function onProjectImageChange(e) {
    const selectedFile = e?.target?.files?.[0] || null;

    clearSelectedImagePreview();
    setProjectImageFile(selectedFile);

    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      selectedImagePreviewRef.current = previewUrl;
      setProjectImagePreview(previewUrl);
      return;
    }

    setProjectImagePreview(projectImageServerPreview);
  }

  function onProjectLogoChange(e) {
    const selectedFile = e?.target?.files?.[0] || null;

    clearSelectedLogoPreview();
    setProjectLogoFile(selectedFile);

    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      selectedLogoPreviewRef.current = previewUrl;
      setProjectLogoPreview(previewUrl);
      return;
    }

    setProjectLogoPreview(projectLogoServerPreview);
  }

  function convertDateToLocale(date) {
    const isoDate = new Date(date);
    const convertedDate = moment(isoDate).format('YYYY-MM-DDTHH:mm');
    return convertedDate;
  }

  function isEmptyRequiredValue(value) {
    return value === '' || value === null || value === undefined;
  }

  function controlProjectUpdateDetail() {
    const requiredErrors = [];
    //project:
    if (!projectDetail.name) {
      requiredErrors.push('project_detail_name');
    }
    // if (!projectDetail.number_of_registrations) {
    //   requiredErrors.push('number_of_registrations');
    // }
    // if (!projectDetail.number_of_participants) {
    //   requiredErrors.push('number_of_participants');
    // }
    if (isEmptyRequiredValue(projectDetail.percent_raised)) {
      requiredErrors.push('percent_raised');
    }
    if (isEmptyRequiredValue(projectDetail.target_raised)) {
      requiredErrors.push('target_raised');
    }
    if (isEmptyRequiredValue(projectDetail.total_tokens_sold)) {
      requiredErrors.push('total_tokens_sold');
    }
    if (isEmptyRequiredValue(projectDetail.total_raised)) {
      requiredErrors.push('total_raised');
    }
    if (!projectDetail.state) {
      requiredErrors.push('state');
    }
    if (!projectDetail.explanation_text) {
      requiredErrors.push('explanation_text');
    }
    if (!projectDetail.website_url) {
      requiredErrors.push('website_url');
    }
    // if (!projectDetail.withdraw_all) {
    //   requiredErrors.push('withdraw_all');
    // }
    // if (!projectDetail.staking_idle_time) {
    //   requiredErrors.push('staking_idle_time');
    // }
    // if (!projectDetail.is_staking_idle) {
    //   requiredErrors.push('is_staking_idle');
    // }
    // if (!projectDetail.is_airdrop) {
    //   requiredErrors.push('is_airdrop');
    // }
    // if (!projectDetail.sale_type) {
    //   requiredErrors.push('sale_type');
    // }
    if (!roundSale.start_date || roundSale.start_date?.toString().includes('Invalid')) {
      requiredErrors.push('round_sale_start_date');
    }
    if (!roundSale.end_date || roundSale.end_date?.toString().includes('Invalid')) {
      requiredErrors.push('round_sale_end_date');
    }
    if (!registrationRound.start_date && registrationRound.end_date) {
      requiredErrors.push('registration_round_start_date');
    }
    if (registrationRound.start_date && !registrationRound.end_date) {
      requiredErrors.push('registration_round_end_date');
    }

    if (!stakingRound.start_date && stakingRound.end_date) {
      requiredErrors.push('staking_round_start_date');
    }
    if (stakingRound.start_date && !stakingRound.end_date) {
      requiredErrors.push('staking_round_end_date');
    }

    if (!publicRound.start_date && publicRound.end_date) {
      requiredErrors.push('public_round_start_date');
    }
    if (publicRound.start_date && !publicRound.end_date) {
      requiredErrors.push('public_round_end_date');
    }

    if (!privateRound.start_date && privateRound.end_date) {
      requiredErrors.push('private_round_start_date');
    }
    if (privateRound.start_date && !privateRound.end_date) {
      requiredErrors.push('private_round_end_date');
    }

    if (!validationRound.start_date && validationRound.end_date) {
      requiredErrors.push('validation_round_start_date');
    }
    if (validationRound.start_date && !validationRound.end_date) {
      requiredErrors.push('validation_round_end_date');
    }
    if (showNft) {
      if (!nftContract.contract_address) {
        requiredErrors.push('nft_contract_address');
      }
      if (!nftContract.contract_owner_address) {
        requiredErrors.push('nft_contract_owner_address');
      }
    }

    setRequiredErrors([...requiredErrors]);
    if (requiredErrors.length) {
      return false;
    } else {
      return true;
    }
  }
  function controlProjectDetail() {
    const requiredErrors = [];
    //project:
    if (!projectDetail.name) {
      requiredErrors.push('project_detail_name');
    }
    if (isEmptyRequiredValue(projectDetail.number_of_registrations)) {
      requiredErrors.push('number_of_registrations');
    }
    if (isEmptyRequiredValue(projectDetail.number_of_participants)) {
      requiredErrors.push('number_of_participants');
    }
    if (isEmptyRequiredValue(projectDetail.percent_raised)) {
      requiredErrors.push('percent_raised');
    }
    if (isEmptyRequiredValue(projectDetail.target_raised)) {
      requiredErrors.push('target_raised');
    }
    if (isEmptyRequiredValue(projectDetail.total_tokens_sold)) {
      requiredErrors.push('total_tokens_sold');
    }
    if (isEmptyRequiredValue(projectDetail.total_raised)) {
      requiredErrors.push('total_raised');
    }
    if (!projectDetail.state) {
      requiredErrors.push('state');
    }
    if (!projectDetail.explanation_text) {
      requiredErrors.push('explanation_text');
    }
    if (!projectDetail.website_url) {
      requiredErrors.push('website_url');
    }
    if (!isNftProjectCreateEditPage && isEmptyRequiredValue(projectDetail.withdraw_all)) {
      requiredErrors.push('withdraw_all');
    }
    if (isEmptyRequiredValue(projectDetail.staking_idle_time)) {
      requiredErrors.push('staking_idle_time');
    }
    if (!isNftProjectCreateEditPage && isEmptyRequiredValue(projectDetail.is_staking_idle)) {
      requiredErrors.push('is_staking_idle');
    }
    if (!isNftProjectCreateEditPage && isEmptyRequiredValue(projectDetail.is_airdrop)) {
      requiredErrors.push('is_airdrop');
    }
    if (!isNftProjectCreateEditPage && !projectDetail.sale_type) {
      requiredErrors.push('sale_type');
    }
    if (!roundSale.start_date || roundSale.start_date?.toString().includes('Invalid')) {
      requiredErrors.push('round_sale_start_date');
    }
    if (!roundSale.end_date || roundSale.end_date?.toString().includes('Invalid')) {
      requiredErrors.push('round_sale_end_date');
    }
    if (!registrationRound.start_date && registrationRound.end_date) {
      requiredErrors.push('registration_round_start_date');
    }
    if (registrationRound.start_date && !registrationRound.end_date) {
      requiredErrors.push('registration_round_end_date');
    }

    if (!stakingRound.start_date && stakingRound.end_date) {
      requiredErrors.push('staking_round_start_date');
    }
    if (stakingRound.start_date && !stakingRound.end_date) {
      requiredErrors.push('staking_round_end_date');
    }

    if (!publicRound.start_date && publicRound.end_date) {
      requiredErrors.push('public_round_start_date');
    }
    if (publicRound.start_date && !publicRound.end_date) {
      requiredErrors.push('public_round_end_date');
    }

    if (!privateRound.start_date && privateRound.end_date) {
      requiredErrors.push('private_round_start_date');
    }
    if (privateRound.start_date && !privateRound.end_date) {
      requiredErrors.push('private_round_end_date');
    }

    if (!validationRound.start_date && validationRound.end_date) {
      requiredErrors.push('validation_round_start_date');
    }
    if (validationRound.start_date && !validationRound.end_date) {
      requiredErrors.push('validation_round_end_date');
    }
    if (showToken) {
      if (!tokenDetail.name) {
        requiredErrors.push('token_detail_name');
      }
      if (!tokenDetail.symbol) {
        requiredErrors.push('token_detail_symbol');
      }
      if (isEmptyRequiredValue(tokenDetail.decimals)) {
        requiredErrors.push('token_detail_decimals');
      }
      if (!tokenDetail.address) {
        requiredErrors.push('token_detail_address');
      }
      if (!tokenDetail.owner_address) {
        requiredErrors.push('token_detail_owner_address');
      }
      if (isEmptyRequiredValue(tokenDetail.all_time_high)) {
        requiredErrors.push('token_detail_all_time_high');
      }
      if (isEmptyRequiredValue(tokenDetail.total_supply)) {
        requiredErrors.push('token_detail_total_supply');
      }
      if (isEmptyRequiredValue(tokenDetail.price_in_usd)) {
        requiredErrors.push('token_detail_price_in_usd');
      }
      if (isEmptyRequiredValue(tokenDetail.price_in_mercurx)) {
        requiredErrors.push('token_detail_price_in_mercurx');
      }
      if (isEmptyRequiredValue(tokenDetail.distribution)) {
        requiredErrors.push('token_detail_distribution');
      }
      if (isEmptyRequiredValue(tokenDetail.current_price)) {
        requiredErrors.push('token_detail_current_price');
      }
    }
    if (showNft) {
      if (!nftDetail.name) {
        requiredErrors.push('nft_detail_name');
      }
      if (!nftDetail.url) {
        requiredErrors.push('nft_detail_url');
      }
      if (!nftDetail.address) {
        requiredErrors.push('nft_detail_address');
      }
      if (!nftDetail.owner_address) {
        requiredErrors.push('nft_detail_owner_address');
      }
      if (isEmptyRequiredValue(nftDetail.total_supply)) {
        requiredErrors.push('nft_detail_total_supply');
      }
      if (isEmptyRequiredValue(nftDetail.price_in_usd)) {
        requiredErrors.push('nft_detail_price_in_usd');
      }
      if (isEmptyRequiredValue(nftDetail.price_in_mercurx)) {
        requiredErrors.push('nft_detail_price_in_mercurx');
      }
      if (isEmptyRequiredValue(nftDetail.distribution)) {
        requiredErrors.push('nft_detail_distribution');
      }
      if (isEmptyRequiredValue(nftDetail.current_price)) {
        requiredErrors.push('nft_detail_current_price');
      }
      if (isEmptyRequiredValue(nftDetail.all_time_high)) {
        requiredErrors.push('nft_detail_all_time_high');
      }
      if (!nftContract.contract_address) {
        requiredErrors.push('nft_contract_address');
      }
      if (!nftContract.contract_owner_address) {
        requiredErrors.push('nft_contract_owner_address');
      }
    }

    setRequiredErrors([...requiredErrors]);
    if (requiredErrors.length) {
      return false;
    } else {
      return true;
    }
  }

  function controlTokenDetail() {
    const requiredErrors = [];

    if (!tokenDetail.name) {
      requiredErrors.push('token_detail_name');
    }
    if (!tokenDetail.symbol) {
      requiredErrors.push('token_detail_symbol');
    }
    if (isEmptyRequiredValue(tokenDetail.decimals)) {
      requiredErrors.push('token_detail_decimals');
    }
    if (!tokenDetail.address) {
      requiredErrors.push('token_detail_address');
    }
    if (!tokenDetail.owner_address) {
      requiredErrors.push('token_detail_owner_address');
    }
    if (isEmptyRequiredValue(tokenDetail.all_time_high)) {
      requiredErrors.push('token_detail_all_time_high');
    }
    if (isEmptyRequiredValue(tokenDetail.total_supply)) {
      requiredErrors.push('token_detail_total_supply');
    }
    if (isEmptyRequiredValue(tokenDetail.price_in_usd)) {
      requiredErrors.push('token_detail_price_in_usd');
    }
    if (isEmptyRequiredValue(tokenDetail.price_in_mercurx)) {
      requiredErrors.push('token_detail_price_in_mercurx');
    }
    if (isEmptyRequiredValue(tokenDetail.distribution)) {
      requiredErrors.push('token_detail_distribution');
    }
    if (isEmptyRequiredValue(tokenDetail.current_price)) {
      requiredErrors.push('token_detail_current_price');
    }

    setRequiredErrors([...requiredErrors]);
    if (requiredErrors.length) {
      return false;
    } else {
      return true;
    }
  }
  function controlNftOnlyDetail() {
    const requiredErrors = [];

    if (!nftDetail.name) {
      requiredErrors.push('nft_detail_name');
    }
    if (!nftDetail.url) {
      requiredErrors.push('nft_detail_url');
    }
    if (!nftDetail.address) {
      requiredErrors.push('nft_detail_address');
    }
    if (!nftDetail.owner_address) {
      requiredErrors.push('nft_detail_owner_address');
    }
    if (isEmptyRequiredValue(nftDetail.total_supply)) {
      requiredErrors.push('nft_detail_total_supply');
    }
    if (isEmptyRequiredValue(nftDetail.price_in_usd)) {
      requiredErrors.push('nft_detail_price_in_usd');
    }
    if (isEmptyRequiredValue(nftDetail.price_in_mercurx)) {
      requiredErrors.push('nft_detail_price_in_mercurx');
    }
    if (isEmptyRequiredValue(nftDetail.distribution)) {
      requiredErrors.push('nft_detail_distribution');
    }
    if (isEmptyRequiredValue(nftDetail.current_price)) {
      requiredErrors.push('nft_detail_current_price');
    }
    if (isEmptyRequiredValue(nftDetail.all_time_high)) {
      requiredErrors.push('nft_detail_all_time_high');
    }
    if (!nftContract.contract_address) {
      requiredErrors.push('nft_contract_address');
    }
    if (!nftContract.contract_owner_address) {
      requiredErrors.push('nft_contract_owner_address');
    }

    setRequiredErrors([...requiredErrors]);
    if (requiredErrors.length) {
      return false;
    } else {
      return true;
    }
  }
  function controlDate() {
    if (roundSale.end_date && roundSale.start_date && roundSale.end_date < roundSale.start_date) {
      DateErrors.push('round_sale_end_date');
    }
    if (roundSale.end_date && roundSale.start_date && roundSale.end_date < roundSale.start_date) {
      DateErrors.push('round_sale_end_date');
    }
    if (registrationRound.end_date < registrationRound.start_date) {
      DateErrors.push('registration_round_end_date');
    }
    if (stakingRound.end_date < stakingRound.start_date) {
      DateErrors.push('staking_round_end_date');
    }
    if (publicRound.end_date < publicRound.start_date) {
      DateErrors.push('public_round_end_date');
    }
    if (privateRound.end_date < privateRound.start_date) {
      DateErrors.push('private_round_end_date');
    }
    if (validationRound.end_date < validationRound.start_date) {
      DateErrors.push('validation_round_end_date');
    }
    setDateErrors([...DateErrors]);
    console.log(DateErrors.length);
    if (DateErrors.length) {
      return false;
    } else {
      return true;
    }
  }

  function controlInputs(key) {
    const errors = new Set(requiredErrors);
    const dateError = new Set(DateErrors);
    if (errors.has(key) || dateError.has(key)) {
      return true;
    } else {
      return false;
    }
  }

  function clearError(key) {
    const errors = new Set(requiredErrors);
    const dateError = new Set(DateErrors);
    if (errors.has(key) || dateError.has(key)) {
      errors.delete(key);
      dateError.delete(key);
    }
    setRequiredErrors([...errors]);
    setDateErrors([...dateError]);
  }

  function updateProject() {
    if (controlProjectUpdateDetail() && controlDate()) {
      if (isNftProjectCreateEditPage) {
        projectDetail.sale_type = 'ido';
        projectDetail.is_staking_idle = false;
        projectDetail.is_airdrop = false;
        projectDetail.withdraw_all = false;
      }

      projectDetail.social = socialDetail;
      if (roundSale.start_date && roundSale.end_date) {
        projectDetail.round_sale = roundSale;
      } else {
        delete projectDetail.round_sale;
      }

      if (registrationRound.start_date && registrationRound.end_date) {
        projectDetail.round_registration = registrationRound;
      } else {
        delete projectDetail.round_registration;
      }

      // projectDetail.round_registration = registrationRound;

      if (stakingRound.start_date && stakingRound.end_date) {
        projectDetail.round_staking = stakingRound;
      } else {
        delete projectDetail.round_staking;
      }
      //  projectDetail.round_staking = stakingRound;
      if (publicRound.start_date && publicRound.end_date) {
        projectDetail.round_publicsale = publicRound;
      } else {
        delete projectDetail.round_publicsale;
      }
      // projectDetail.round_publicsale = publicRound;
      if (privateRound.start_date && privateRound.end_date) {
        projectDetail.round_privatesale = privateRound;
      } else {
        delete projectDetail.round_privatesale;
      }
      // projectDetail.round_privatesale = privateRound;
      if (validationRound.start_date && validationRound.end_date) {
        projectDetail.round_validation = validationRound;
      } else {
        delete projectDetail.round_validation;
      }
      // projectDetail.round_validation = validationRound;
      delete projectDetail.token;
      const payload = {
        projectID: project.id,
        body: projectDetail,
        media: {
          image: projectImageFile,
          logo: projectLogoFile,
        },
      };

      setIsUpdateProjectSubmitting(true);
      updateProjectRequest(payload);
    }
  }

  function createProject() {
    if (controlProjectDetail() && controlDate()) {
      if (roundSale.start_date && roundSale.end_date) {
        projectDetail.round_sale = roundSale;
      } else {
        delete projectDetail.round_sale;
      }
      if (registrationRound.start_date && registrationRound.end_date) {
        projectDetail.round_registration = registrationRound;
      } else {
        delete projectDetail.round_registration;
      }
      if (stakingRound.start_date && stakingRound.end_date) {
        projectDetail.round_staking = stakingRound;
      } else {
        delete projectDetail.round_staking;
      }
      if (publicRound.start_date && publicRound.end_date) {
        projectDetail.round_publicsale = publicRound;
      } else {
        delete projectDetail.round_publicsale;
      }
      if (privateRound.start_date && privateRound.end_date) {
        projectDetail.round_privatesale = privateRound;
      } else {
        delete projectDetail.round_privatesale;
      }
      if (validationRound.start_date && validationRound.end_date) {
        projectDetail.round_validation = validationRound;
      } else {
        delete projectDetail.round_validation;
      }

      projectDetail.social = socialDetail;
      if (isNftProjectCreateEditPage) {
        projectDetail.sale_type = 'ido';
        projectDetail.is_staking_idle = false;
        projectDetail.is_airdrop = false;
        projectDetail.withdraw_all = false;
      }
      if (showNft) {
        delete projectDetail.token;
        projectDetail.nft = nftDetail;
        projectDetail.nft.nft_contract = nftContract;
      } else {
        delete projectDetail.nft;
        projectDetail.token = tokenDetail;
        projectDetail.token.staking_contract = stakingContract;
        projectDetail.token.presale_contract = presaleContract;
      }

      const payload = {
        body: projectDetail,
        media: {
          image: projectImageFile,
          logo: projectLogoFile,
        },
      };
      setIsCreateProjectSubmitting(true);
      createProjectRequest(payload);
    }
  }

  function createToken() {
    if (controlTokenDetail()) {
      if (tokenDetail.staking_contract) {
        tokenDetail.staking_contract = stakingContract;
      } else {
        delete tokenDetail.staking_contract;
      }
      if (tokenDetail.presale_contract) {
        tokenDetail.presale_contract = presaleContract;
      } else {
        delete tokenDetail.presale_contract;
      }
      const payload = {
        body: tokenDetail,
      };

      createTokenRequest(payload);
      setTimeout(() => {
        history.goBack();
      }, 2000);
    }
  }
  function createNftProject() {
    createProject();
  }
  function createNftOnlyProject() {
    if (controlNftOnlyDetail()) {
      const normalizeNumber = (value) => (value === '' || value === null ? 0 : Number(value));
      const payload = {
        body: {
          nft: {
            ...nftDetail,
            total_supply: normalizeNumber(nftDetail.total_supply),
            price_in_usd: normalizeNumber(nftDetail.price_in_usd),
            price_in_mercurx: normalizeNumber(nftDetail.price_in_mercurx),
            distribution: normalizeNumber(nftDetail.distribution),
            current_price: normalizeNumber(nftDetail.current_price),
            all_time_high: normalizeNumber(nftDetail.all_time_high),
            nft_contract: { ...nftContract },
          },
        },
      };

      setIsCreateProjectSubmitting(true);
      createProjectRequest(payload);
    }
  }
  function updateToken() {
    if (controlTokenDetail()) {
      if (tokenDetail.staking_contract) {
        tokenDetail.staking_contract = stakingContract;
      } else {
        delete tokenDetail.staking_contract;
      }
      if (tokenDetail.presale_contract) {
        tokenDetail.presale_contract = presaleContract;
      } else {
        delete tokenDetail.presale_contract;
      }
      const payload = {
        tokenID: token.id,
        body: tokenDetail,
      };

      updateTokenRequest(payload);
      setTimeout(() => {
        history.goBack();
      }, 2000);
    }
  }

  if (isEdit && !project && !token) {
    return null;
  }

  const showOnlyNftSection =
    showNft && !showProject && !showToken && !showContract && !showSocial;
  const nftAccordionKey = showOnlyNftSection ? '0' : '1-nft';

  const defaultAccordionKeys = [];
  if (showProject) defaultAccordionKeys.push('0');
  if (showToken) defaultAccordionKeys.push('1');
  if (showNft) defaultAccordionKeys.push(nftAccordionKey);
  if (showContract) defaultAccordionKeys.push('2');
  if (showSocial) defaultAccordionKeys.push('3');

  return (
    <div className="project-detail">
      <Accordion className="mt-5 shadow" defaultActiveKey={defaultAccordionKeys} alwaysOpen>
        {showProject && (
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <div className="text-fs-head-sm">Project</div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Name*</Form.Label>
                    <Form.Control
                      id="name"
                      type="text"
                      value={projectDetail.name}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('project_detail_name')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Project Image</Form.Label>
                    <Form.Control type="file" accept="image/*" onChange={onProjectImageChange} />
                    {projectImagePreview && (
                      <div className="project-detail__media-preview mt-2">
                        <img src={projectImagePreview} alt="project-image-preview" />
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Project Logo</Form.Label>
                    <Form.Control type="file" accept="image/*" onChange={onProjectLogoChange} />
                    {projectLogoPreview && (
                      <div className="project-detail__media-preview mt-2">
                        <img src={projectLogoPreview} alt="project-logo-preview" />
                      </div>
                    )}
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Number of Registrations*</Form.Label>
                    <Form.Control
                      id="number_of_registrations"
                      type="number"
                      value={projectDetail.number_of_registrations}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('number_of_registrations')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Number of Participants*</Form.Label>
                    <Form.Control
                      id="number_of_participants"
                      type="number"
                      value={projectDetail.number_of_participants}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('number_of_participants')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Percent Raised*</Form.Label>
                    <Form.Control
                      id="percent_raised"
                      type="number"
                      value={projectDetail.percent_raised}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('percent_raised')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Target Raised*</Form.Label>
                    <Form.Control
                      id="target_raised"
                      type="number"
                      value={projectDetail.target_raised}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('target_raised')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Explanation Text*</Form.Label>
                    <Form.Control
                      id="explanation_text"
                      as="textarea"
                      value={projectDetail.explanation_text}
                      onChange={projectDetailOnChange}
                      rows={3}
                      isInvalid={controlInputs('explanation_text')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Staking Idle Time*</Form.Label>
                    <Form.Control
                      id="staking_idle_time"
                      type="datetime-local"
                      value={convertDateToLocale(projectDetail.staking_idle_time)}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('staking_idle_time')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Sale Start Date*</Form.Label>
                    <Form.Control
                      id="start_date"
                      type="datetime-local"
                      value={convertDateToLocale(roundSale.start_date)}
                      onChange={roundSaleDetailOnChange}
                      isInvalid={controlInputs('round_sale_start_date')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Sale End Date*</Form.Label>
                    <Form.Control
                      id="end_date"
                      type="datetime-local"
                      value={convertDateToLocale(roundSale.end_date)}
                      onChange={roundSaleDetailOnChange}
                      isInvalid={controlInputs('round_sale_end_date')}
                    />
                  </Form.Group>
                  {!isNftProjectCreateEditPage && (
                    <>
                      <Form.Group className="mt-2">
                        <Form.Label>Registration Round Start Date</Form.Label>
                        <Form.Control
                          id="start_date"
                          type="datetime-local"
                          value={convertDateToLocale(registrationRound.start_date)}
                          onChange={registrationRoundDetailOnChange}
                          isInvalid={controlInputs('registration_round_start_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Registration Round End Date</Form.Label>
                        <Form.Control
                          id="end_date"
                          type="datetime-local"
                          value={convertDateToLocale(registrationRound.end_date)}
                          onChange={registrationRoundDetailOnChange}
                          isInvalid={controlInputs('registration_round_end_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Registration Round Description</Form.Label>
                        <Form.Control
                          id="description"
                          type="text"
                          value={registrationRound.description}
                          onChange={registrationRoundDetailTextOnChange}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Staking Round Start Date</Form.Label>
                        <Form.Control
                          id="start_date"
                          type="datetime-local"
                          value={convertDateToLocale(stakingRound.start_date)}
                          onChange={stakingRoundDetailOnChange}
                          isInvalid={controlInputs('staking_round_start_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Staking Round End Date</Form.Label>
                        <Form.Control
                          id="end_date"
                          type="datetime-local"
                          value={convertDateToLocale(stakingRound.end_date)}
                          onChange={stakingRoundDetailOnChange}
                          isInvalid={controlInputs('staking_round_end_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Staking Round Description</Form.Label>
                        <Form.Control
                          id="description"
                          type="text"
                          value={stakingRound.description}
                          onChange={stakingRoundDetailTextOnChange}
                        />
                      </Form.Group>
                    </>
                  )}
                </Col>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Total Raised*</Form.Label>
                    <Form.Control
                      id="total_raised"
                      type="number"
                      value={projectDetail.total_raised}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('total_raised')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Total Tokens Sold*</Form.Label>
                    <Form.Control
                      id="total_tokens_sold"
                      type="number"
                      value={projectDetail.total_tokens_sold}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('total_tokens_sold')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>State*</Form.Label>
                    <Form.Control
                      id="state"
                      type="text"
                      value={projectDetail.state}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('state')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Website URL*</Form.Label>
                    <Form.Control
                      id="website_url"
                      type="text"
                      value={projectDetail.website_url}
                      onChange={projectDetailOnChange}
                      isInvalid={controlInputs('website_url')}

                    />
                  </Form.Group>
                  {!isNftProjectCreateEditPage && (
                    <>
                      <div className="d-flex justify-content-around">
                        <Form.Group className="mt-2">
                          <Form.Label>Sale Type*</Form.Label>
                          <div className="d-flex">
                            <Form.Check
                              className="me-3"
                              id="sale_type"
                              type="radio"
                              label="ido"
                              checked={projectDetail.sale_type === 'ido'}
                              onChange={(e) => projectDetailOnChange(e, 'ido')}
                              isInvalid={controlInputs('sale_type')}
                            />
                            <Form.Check
                              id="sale_type"
                              type="radio"
                              label="ico"
                              checked={projectDetail.sale_type === 'ico'}
                              onChange={(e) => projectDetailOnChange(e, 'ico')}
                              isInvalid={controlInputs('sale_type')}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group className="mt-2">
                          <Form.Label>Staking Idle*</Form.Label>
                          <div className="d-flex">
                            <Form.Check
                              className="me-3"
                              id="is_staking_idle"
                              type="radio"
                              label="True"
                              checked={projectDetail.is_staking_idle}
                              onChange={(e) => projectDetailOnChange(e, true)}
                            />
                            <Form.Check
                              id="is_staking_idle"
                              type="radio"
                              label="False"
                              checked={!projectDetail.is_staking_idle}
                              onChange={(e) => projectDetailOnChange(e, false)}
                            />
                          </div>
                        </Form.Group>
                      </div>
                      <div className="d-flex justify-content-around">
                        <Form.Group className="mt-2">
                          <Form.Label>Airdrop*</Form.Label>
                          <div className="d-flex">
                            <Form.Check
                              className="me-3"
                              id="is_airdrop"
                              type="radio"
                              label="True"
                              checked={projectDetail.is_airdrop}
                              onChange={(e) => projectDetailOnChange(e, true)}
                            />
                            <Form.Check
                              id="is_airdrop"
                              type="radio"
                              label="False"
                              checked={!projectDetail.is_airdrop}
                              onChange={(e) => projectDetailOnChange(e, false)}
                            />
                          </div>
                        </Form.Group>
                        <Form.Group className="mt-2">
                          <Form.Label>Withdraw All*</Form.Label>
                          <div className="d-flex">
                            <Form.Check
                              className="me-3"
                              id="withdraw_all"
                              type="radio"
                              label="True"
                              checked={projectDetail.withdraw_all}
                              onChange={(e) => projectDetailOnChange(e, true)}
                            />
                            <Form.Check
                              id="withdraw_all"
                              type="radio"
                              label="False"
                              checked={!projectDetail.withdraw_all}
                              onChange={(e) => projectDetailOnChange(e, false)}
                            />
                          </div>
                        </Form.Group>
                      </div>
                      <Form.Group className="mt-2">
                        <Form.Label>Public Sale Start Date</Form.Label>
                        <Form.Control
                          id="start_date"
                          type="datetime-local"
                          value={convertDateToLocale(publicRound.start_date)}
                          onChange={publicRoundDetailOnChange}
                          isInvalid={controlInputs('public_round_start_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Public Sale End Date</Form.Label>
                        <Form.Control
                          id="end_date"
                          type="datetime-local"
                          value={convertDateToLocale(publicRound.end_date)}
                          onChange={publicRoundDetailOnChange}
                          isInvalid={controlInputs('public_round_end_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Public Sale Description</Form.Label>
                        <Form.Control
                          id="description"
                          type="text"
                          value={publicRound.description}
                          onChange={publicRoundDetailTextOnChange}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Private Sale Start Date</Form.Label>
                        <Form.Control
                          id="start_date"
                          type="datetime-local"
                          value={convertDateToLocale(privateRound.start_date)}
                          onChange={privateRoundDetailOnChange}
                          isInvalid={controlInputs('private_round_start_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Private Sale End Date</Form.Label>
                        <Form.Control
                          id="end_date"
                          type="datetime-local"
                          value={convertDateToLocale(privateRound.end_date)}
                          onChange={privateRoundDetailOnChange}
                          isInvalid={controlInputs('private_round_end_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Private Sale Description</Form.Label>
                        <Form.Control
                          id="description"
                          type="text"
                          value={privateRound.description}
                          onChange={privateRoundDetailTextOnChange}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Validation Round Sale Start Date</Form.Label>
                        <Form.Control
                          id="start_date"
                          type="datetime-local"
                          value={convertDateToLocale(validationRound.start_date)}
                          onChange={validationRoundDetailOnChange}
                          isInvalid={controlInputs('validation_round_start_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Validation Round Sale End Date</Form.Label>
                        <Form.Control
                          id="end_date"
                          type="datetime-local"
                          value={convertDateToLocale(validationRound.end_date)}
                          onChange={validationRoundDetailOnChange}
                          isInvalid={controlInputs('validation_round_end_date')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>Validation Round Sale Description</Form.Label>
                        <Form.Control
                          id="description"
                          type="text"
                          value={validationRound.description}
                          onChange={validationRoundDetailTextOnChange}
                        />
                      </Form.Group>
                    </>
                  )}
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {showToken && (
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <div className="text-fs-head-sm">Token</div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Token Name*</Form.Label>
                    <Form.Control
                      id="name"
                      type="text"
                      value={tokenDetail.name}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_name')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Token Symbol*</Form.Label>
                    <Form.Control
                      id="symbol"
                      type="text"
                      value={tokenDetail.symbol}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_symbol')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Token Decimals*</Form.Label>
                    <Form.Control
                      id="decimals"
                      type="number"
                      value={tokenDetail.decimals}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_decimals')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Token Address*</Form.Label>
                    <Form.Control
                      id="address"
                      type="text"
                      value={tokenDetail.address}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_address')}

                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Token Owner Address*</Form.Label>
                    <Form.Control
                      id="owner_address"
                      type="text"
                      value={tokenDetail.owner_address}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_owner_address')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>All Time High*</Form.Label>
                    <Form.Control
                      id="all_time_high"
                      type="number"
                      value={tokenDetail.all_time_high}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_all_time_high')}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Total Supply*</Form.Label>
                    <Form.Control
                      id="total_supply"
                      type="number"
                      value={tokenDetail.total_supply}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_total_supply')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Price in USD*</Form.Label>
                    <Form.Control
                      id="price_in_usd"
                      type="number"
                      value={tokenDetail.price_in_usd}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_price_in_usd')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Price in Mercurx*</Form.Label>
                    <Form.Control
                      id="price_in_mercurx"
                      type="number"
                      value={tokenDetail.price_in_mercurx}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_price_in_mercurx')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Distribution*</Form.Label>
                    <Form.Control
                      id="distribution"
                      type="number"
                      value={tokenDetail.distribution}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_distribution')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Current Price*</Form.Label>
                    <Form.Control
                      id="current_price"
                      type="number"
                      value={tokenDetail.current_price}
                      onChange={tokenDetailOnChange}
                      isInvalid={controlInputs('token_detail_current_price')}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {showNft && (
          <Accordion.Item eventKey={nftAccordionKey}>
            <Accordion.Header>
              <div className="text-fs-head-sm">NFT</div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>NFT Name*</Form.Label>
                    <Form.Control
                      id="name"
                      type="text"
                      value={nftDetail.name}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_name')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>NFT URL*</Form.Label>
                    <Form.Control
                      id="url"
                      type="text"
                      value={nftDetail.url}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_url')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>NFT Address*</Form.Label>
                    <Form.Control
                      id="address"
                      type="text"
                      value={nftDetail.address}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_address')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>NFT Owner Address*</Form.Label>
                    <Form.Control
                      id="owner_address"
                      type="text"
                      value={nftDetail.owner_address}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_owner_address')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>All Time High*</Form.Label>
                    <Form.Control
                      id="all_time_high"
                      type="number"
                      value={nftDetail.all_time_high}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_all_time_high')}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Total Supply*</Form.Label>
                    <Form.Control
                      id="total_supply"
                      type="number"
                      value={nftDetail.total_supply}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_total_supply')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Price in USD*</Form.Label>
                    <Form.Control
                      id="price_in_usd"
                      type="number"
                      value={nftDetail.price_in_usd}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_price_in_usd')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Price in Mercurx*</Form.Label>
                    <Form.Control
                      id="price_in_mercurx"
                      type="number"
                      value={nftDetail.price_in_mercurx}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_price_in_mercurx')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Distribution*</Form.Label>
                    <Form.Control
                      id="distribution"
                      type="number"
                      value={nftDetail.distribution}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_distribution')}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Current Price*</Form.Label>
                    <Form.Control
                      id="current_price"
                      type="number"
                      value={nftDetail.current_price}
                      onChange={nftDetailOnChange}
                      isInvalid={controlInputs('nft_detail_current_price')}
                    />
                  </Form.Group>
                  {!showContract && (
                    <>
                      <Form.Group className="mt-2">
                        <Form.Label>NFT Sale Contract Address*</Form.Label>
                        <Form.Control
                          id="contract_address"
                          type="text"
                          value={nftContract.contract_address}
                          onChange={nftContractOnChange}
                          isInvalid={controlInputs('nft_contract_address')}
                        />
                      </Form.Group>
                      <Form.Group className="mt-2">
                        <Form.Label>NFT Sale Contract Owner Address*</Form.Label>
                        <Form.Control
                          id="contract_owner_address"
                          type="text"
                          value={nftContract.contract_owner_address}
                          onChange={nftContractOnChange}
                          isInvalid={controlInputs('nft_contract_owner_address')}
                        />
                      </Form.Group>
                    </>
                  )}
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        )}
        {showContract && (
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <div className="text-fs-head-sm">Contract</div>
            </Accordion.Header>
            <Accordion.Body>
              {showNft ? (
                <Row>
                  <Col md="6">
                    <Form.Group className="mt-2">
                      <Form.Label>NFT Sale Contract Address*</Form.Label>
                      <Form.Control
                        id="contract_address"
                        type="text"
                        value={nftContract.contract_address}
                        onChange={nftContractOnChange}
                        isInvalid={controlInputs('nft_contract_address')}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className="mt-2">
                      <Form.Label>NFT Sale Contract Owner Address*</Form.Label>
                      <Form.Control
                        id="contract_owner_address"
                        type="text"
                        value={nftContract.contract_owner_address}
                        onChange={nftContractOnChange}
                        isInvalid={controlInputs('nft_contract_owner_address')}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col md="6">
                    <Form.Group className="mt-2">
                      <Form.Label>Staking Contract Address</Form.Label>
                      <Form.Control
                        id="contract_address"
                        type="text"
                        value={stakingContract.contract_address}
                        onChange={stakingContractOnChange}
                      />
                    </Form.Group>
                    <Form.Group className="mt-2">
                      <Form.Label>Staking Contract Owner Address</Form.Label>
                      <Form.Control
                        id="contract_owner_address"
                        type="text"
                        value={stakingContract.contract_owner_address}
                        onChange={stakingContractOnChange}
                      />
                    </Form.Group>
                    <Form.Group className="mt-2">
                      <Form.Label>Staking Reward Token Address</Form.Label>
                      <Form.Control
                        id="reward_token_address"
                        type="text"
                        value={stakingContract.reward_token_address}
                        onChange={stakingContractOnChange}
                      />
                    </Form.Group>
                    <Form.Group className="mt-2">
                      <Form.Label>Staking Reward Token Owner Address</Form.Label>
                      <Form.Control
                        id="reward_token_owner_address"
                        type="text"
                        value={stakingContract.reward_token_owner_address}
                        onChange={stakingContractOnChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group className="mt-2">
                      <Form.Label>Presale Contract Address</Form.Label>
                      <Form.Control
                        id="contract_address"
                        type="text"
                        value={presaleContract.contract_address}
                        onChange={presaleContractOnChange}
                      />
                    </Form.Group>
                    <Form.Group className="mt-2">
                      <Form.Label>Presale Contract Owner Address</Form.Label>
                      <Form.Control
                        id="contract_owner_address"
                        type="text"
                        value={presaleContract.contract_owner_address}
                        onChange={presaleContractOnChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </Accordion.Body>
          </Accordion.Item>
        )}
        {showSocial && (
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <div className="text-fs-head-sm">Social</div>
            </Accordion.Header>
            <Accordion.Body>
              <Row>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Twitter</Form.Label>
                    <Form.Control
                      id="twitter"
                      type="text"
                      value={socialDetail.twitter}
                      onChange={socialDetailOnChange}
                    />
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>Telegram</Form.Label>
                    <Form.Control
                      id="telegram"
                      type="text"
                      value={socialDetail.telegram}
                      onChange={socialDetailOnChange}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group className="mt-2">
                    <Form.Label>Discord</Form.Label>
                    <Form.Control
                      id="discord"
                      type="text"
                      value={socialDetail.discord}
                      onChange={socialDetailOnChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>

      <div className="text-end project-detail__actions">
        {requiredErrors.length > 0 ? (
          <div className="text-danger mt-2">*Required fields must be fill.</div>
        ) : (
          <></>
        )}
        {DateErrors.length > 0 ? (
          <div className="text-danger mt-2">*The date is invalid.</div>
        ) : (
          <></>
        )}
        {isEdit && showProject && user.is_superuser && (
          <Button className="mt-2" onClick={updateProject}>
            update Project
          </Button>
        )}
        {!isEdit && showProject && user.is_superuser && (
          <Button
            className="mt-2"
            onClick={showNft ? createNftProject : createProject}
          >
            {showNft ? 'Create NFT Project' : 'Create Project'}
          </Button>
        )}
        {!showProject && !isEdit && showNft && user.is_superuser && (
          <Button className="mt-2" onClick={createNftOnlyProject}>
            Create NFT Project
          </Button>
        )}
        {!showProject && isEdit && showToken && user.is_superuser && (
          <Button className="mt-2" onClick={updateToken}>
            update Token
          </Button>
        )}
        {!showProject && !isEdit && showToken && user.is_superuser && (
          <Button className="mt-2" onClick={createToken}>
            Create Token
          </Button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    project: state.projectReducer.project,
    createdProject: state.projectReducer.createdProject,
    updatedProject: state.projectReducer.updatedProject,
    projectErrorType: state.projectReducer.error?.type,
    // token: state.tokenReducer.token,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createProjectRequest: (payload) => {
      dispatch(createProjectActionRequest(payload));
    },
    updateProjectRequest: (payload) => {
      dispatch(updateProjectActionRequest(payload));
    },
    createTokenRequest: (payload) => {
      dispatch(createTokenActionRequest(payload));
    },
    updateTokenRequest: (payload) => {
      dispatch(updateTokenActionRequest(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MercurXProjectDetailInputs);
